const About = () => {
  return (
    <section id="sobre" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Image */}
          <div className="relative">
            <div className="w-full h-[420px] md:h-[540px] rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/21e19603d42babf1dc4380dbdbe591fa/8cd16a986f83be5644ac7bd5f45132c6.png"
                alt="Equipe MG+ Saúde & Estética"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-6 -right-4 md:-right-8 bg-white rounded-xl px-6 py-4 border border-[#F0EAE0] max-w-[200px]">
              <p className="font-cormorant text-3xl text-[#C4A45A] font-semibold">+10 anos</p>
              <p className="font-raleway text-xs text-[#8B8680] tracking-wide mt-1">de cuidado e excelência em saúde e estética</p>
            </div>
            {/* Gold accent */}
            <div className="absolute -top-4 -left-4 w-24 h-24 rounded-full border border-[#C4A45A]/30 -z-10" />
          </div>

          {/* Text */}
          <div className="lg:pl-6">
            <span className="text-[#C4A45A] text-xs tracking-[0.35em] uppercase font-raleway block mb-4">
              Nossa História
            </span>
            <h2 className="font-cormorant text-4xl md:text-5xl text-[#2C2B29] font-light leading-snug mb-6">
              Mais do que estética,<br />
              <em>cuidado que acolhe</em>
            </h2>
            <p className="font-raleway text-[#6B6560] text-sm md:text-base leading-relaxed mb-5">
              A <strong>MG+ Saúde &amp; Estética</strong> nasceu da convicção de que cada pessoa merece atenção plena, um tratamento individualizado e resultados que respeitam sua identidade. Localizada no <strong>Centro de Santo André</strong>, nossa clínica une tecnologia de ponta, protocolos seguros e um ambiente que transmite paz.
            </p>
            <p className="font-raleway text-[#6B6560] text-sm md:text-base leading-relaxed mb-8">
              Nossa missão vai além da beleza: queremos que você saia daqui se sentindo <strong>mais confiante, mais leve e mais você</strong>. Cada detalhe — da recepção ao pós-tratamento — é pensado para proporcionar uma experiência premium de bem‑estar em Santo André.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              {[
                { icon: 'ri-shield-check-line', label: 'Protocolos Seguros' },
                { icon: 'ri-heart-pulse-line', label: 'Cuidado Humanizado' },
                { icon: 'ri-sparkling-line', label: 'Resultados Naturais' },
                { icon: 'ri-user-heart-line', label: 'Atendimento Exclusivo' },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#FAF7F2] text-[#C4A45A]">
                    <i className={`${item.icon} text-base`}></i>
                  </div>
                  <span className="font-raleway text-xs text-[#6B6560] tracking-wide">{item.label}</span>
                </div>
              ))}
            </div>

            <button
              onClick={() => document.querySelector('#contato')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-[#C4A45A] text-white font-raleway text-xs tracking-[0.2em] uppercase px-7 py-3 rounded-full hover:bg-[#B8975A] transition-all cursor-pointer whitespace-nowrap"
            >
              Agende sua Avaliação
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
